const apiBase = process.env.REACT_APP_ZOOM_API_BASE || '';

async function handleResponse(res) {
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    throw new Error(payload?.error || 'Unable to load enrollments.');
  }
  return payload;
}

export async function getStudentEnrollments(studentId) {
  if (!studentId) throw new Error('studentId is required');
  const res = await fetch(`${apiBase}/api/enrollments/student/${studentId}`);
  return handleResponse(res);
}

export async function getStudentsForTeacher(teacherId) {
  if (!teacherId) throw new Error('teacherId is required');
  const res = await fetch(`${apiBase}/api/enrollments/teacher/${teacherId}`);
  return handleResponse(res);
}

export async function getEnrollmentStats() {
  const res = await fetch(`${apiBase}/api/enrollments/stats`);
  return handleResponse(res);
}

export async function createEnrollment({ studentId, courseId, teacherId, status, notes }) {
  if (!studentId || !courseId) throw new Error('studentId and courseId are required');
  const res = await fetch(`${apiBase}/api/enrollments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ studentId, courseId, teacherId, status, notes }),
  });
  return handleResponse(res);
}
